import { useDictText, useEnumSourceText, useProcessTypeText } from './dictOptions';
import { useMModeText } from './mmodeText';

// 加工参数值 → 中文的公共取值器 (数据资产各中心的详情页共用).
//
// 这些页面展示的参数来自三个源 (prism 存档 / xcs2.7 上报 / 本平台参数库), 同一个字段在三边的
// 命名风格不同 (process_head / processHead), 值域却是同一套平台枚举. 取名规则:
//   加工模式 → mm_mode 字典 (★设计A 的模式词表, 不是 dict 类目)
//   工艺类型 → dict process_type (按框架 scope 分列表, 展示侧跨框架合并)
//   其余字段 → 该字段在 schema_field.enums_source 上挂的 dict 类目 (SSOT 说哪个字段用哪本字典)
// 字典没收录的 code 一律回退原值, 不吞数据.
//
// KEY_ALIAS 只做"源侧命名 → 平台字段键"的桥接, 不是 code→中文 的词表: 中文永远来自字典.

const KEY_ALIAS: Record<string, string> = {
    craft: 'processingType',
    laser_source: 'processingLightSource',
    lightSource: 'processingLightSource',
    light_source: 'processingLightSource',
};

const toCamel = (k: string) => k.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());

/** 归一到平台字段键 (schema_field.field_key). */
export function normalizeParamKey(key: string): string {
    return KEY_ALIAS[key] || KEY_ALIAS[toCamel(key)] || toCamel(key);
}

export function useParamValueText(): (key: string, value: unknown, fallback?: string) => string {
    const modeText = useMModeText();
    const typeText = useProcessTypeText();
    const enumText = useEnumSourceText();
    const headText = useDictText('process_head');
    return (key, value, fallback = '—') => {
        if (value === null || value === undefined || value === '') return fallback;
        const raw = String(value);
        const k = normalizeParamKey(key);
        if (k === 'processingMode' || k === 'mode' || k === 'processMode') return modeText(raw, raw);
        if (k === 'processingType') return typeText(raw, raw);
        // 加工头在 schema_field 上已挂 process_head; 直连字典兜一层, 免得字段字典缺行时裸显 code.
        if (k === 'processHead') return headText(raw, raw);
        return enumText(k, raw);
    };
}
